export default __webpack_public_path__ + "static/media/21-Soundcloud-Black.c85df390.png";